import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HeardContainer from "../components/heardContainer";
import chatGif from "../assets/gif/chat.gif"
import chatGif01 from "../assets/gif/chat01.gif"
export default function ChatPage () {
    document.title = '海马‑即时通讯'
    const keyword = document.querySelector('meta[name="keyword"]')
    keyword.setAttribute('content', '海马聊天、聊天系统、私有化部署、独立部署、社交媒体聊天、即时聊天、IM、chat')
    const description = document.querySelector('meta[name="description"]')
    description.setAttribute('content', '支持独立部署的个人云社交媒体分布式在线聊天平台，全面兼容安卓、iOS、网页及PC端，多端无缝切换，沟通更高效。通信全程采用 AES 加密，服务器加入集群后会自动分配唯一编号与会话密钥，实现全链路安全加密传输。')
    const slides = [
        {
            title: "智能 · 高效 · 创新未来",
            desc: "AI赋能企业数字化升级",
            img: chatGif,
        },
        {
            title: "一体化客户联络平台",
            desc: "全渠道打通，让沟通更顺畅",
            img: chatGif01,
        },

    ];

    const [index, setIndex] = useState(0);
    const nextSlide = () => setIndex((index + 1) % slides.length);
    const prevSlide = () => setIndex((index - 1 + slides.length) % slides.length);
    return (
        <div className="bg-gradient-radial from-[#7b61ff]/10 via-transparent to-[#070814] text-[#eaf5ff] font-sans">
            <div className="max-w-6xl mx-auto p-7">
                {/* Header */}
                <HeardContainer tilte="海马‑即时通讯" subtitle="轻量 · 极速 · 科技感" />
                {/* Hero Section */}
                <section className="grid md:grid-cols-2 gap-7 mt-9">
                    {/* Left Card */}
                    <div className="bg-white/5 p-7 rounded-2xl backdrop-blur-md shadow-[0_10px_30px_rgba(2,6,23,0.6)]">
                        <div className="flex items-center gap-3">
                            <h2 className="text-lg">海马‑即时通讯 ❤️单聊，群聊想怎么聊怎么聊❤️</h2>
                        </div>
                        <p className="text-[#ffffff99] mt-2">
                            <span className="text-white">✅</span>文字、表情、图片、文件等丰富的消息特性<br />
                            <span className="text-white">✅</span>语音消息、语音通话、视频通话、视频消息<br />
                            <span className="text-white">✅</span>尽情释放个性，覆盖各种社交场景<br />
                            <span className="text-white">✅</span>可监控所有单聊、群聊聊天记录
                        </p>
                        <div className="flex flex-wrap gap-2 mt-4">
                            {['端到端可扩展', '端对端加密', '企业级安全', '低延迟传输'].map(chip => (
                                <span key={chip} className="px-3 py-2 rounded-full bg-white/2 border border-white/5 text-xs">{chip}</span>
                            ))}
                        </div>
                        <div className="grid md:grid-cols-3 gap-4 mt-5">
                            <div className="p-4 rounded-xl bg-white/5 border border-white/5">
                                <h3 className="text-sm mt-2 mb-1">消息类型丰富</h3>
                                <p className="text-xs text-[#ffffff99]">支持文字、图片、文件、表情、语音与视频。</p>
                            </div>
                            <div className="p-4 rounded-xl bg-white/5 border border-white/5">
                                <h3 className="text-sm mt-2 mb-1">实时通话</h3>
                                <p className="text-xs text-[#ffffff99]">低延迟语音/视频通话，适配弱网络。</p>
                            </div>
                            <div className="p-4 rounded-xl bg-white/5 border border-white/5">
                                <h3 className="text-sm mt-2 mb-1">管理与监控</h3>
                                <p className="text-xs text-[#ffffff99]">支持消息实时监控，消息实时智能报警，满足企业合规需求。</p>
                            </div>
                        </div>
                    </div>

                    {/* Right Mock Chat */}
                    <div className="relative bg-gradient-to-b from-[#061022] to-[#081226] rounded-xl border border-white/10 h-[26rem] overflow-hidden">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.95 }}
                                transition={{ duration: 0.8 }}
                                className="flex items-center justify-items-center h-full"
                            >
                                <img
                                    src={slides[index].img}
                                    alt="海马‑即时通讯"
                                    className="w-full max-w-3xl rounded-2xl shadow-2xl"
                                />
                            </motion.div>
                        </AnimatePresence>

                        <div className="absolute left-3 top-1/2 -translate-y-1/2 flex justify-center items-center gap-4 ">
                            <button onClick={prevSlide} className="px-4 py-2 bg-slate-800/60 rounded-full hover:bg-slate-700 transition">←</button>
                        </div>
                        <div className="absolute right-3 top-1/2 -translate-y-1/2 flex justify-center items-center gap-4">
                            <button onClick={nextSlide} className="px-4 py-2 bg-slate-800/60 rounded-full hover:bg-slate-700 transition">→</button>
                        </div>
                        <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2">
                            {slides.map((s, i) => (
                                <div
                                    key={i}
                                    onClick={nextSlide}
                                    className={`w-3 h-3 rounded-full transition-all duration-500 ${i === index ? "bg-gradient-to-r from-sky-400 to-indigo-500 w-6" : "bg-slate-600"
                                        }`}
                                >
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer className="mt-10 text-center text-xs text-[#ffffff99]">
                    <div> 海马‑即时通讯 · 适用于企业与个人</div>
                    <div className="relative mt-4">
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
                        <div className="absolute left-1/2 -translate-x-1/2 inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />
                    </div>
                </footer>
            </div>
        </div>
    );
}
